import { Box, ButtonProps, Checkbox, HStack, Text, VStack } from '@chakra-ui/react'

import * as React from 'react'
// import { AssessmentInterfaceContext } from '../../contexts/AssessmentContext'

import { getDateString } from '@hb/shared'
import { useCallback, useMemo, useState } from 'react'
import { useProfile } from '../../../contexts/user/ProfileContext'
import { useUpdateDoc } from '../../../hooks/backend/useUpdateDoc'
import { ConfirmAlertButton } from '../../Buttons/ConfirmAlertButton'
import { Expandable } from '../../Expandable'
import { LoadingOverlay } from '../../LoadingOverlay'
import { AssessmentLog } from '../../Users/Profile/Log/AssessmentLog'
import { ScheduledCallButton } from '../SignOn/ScheduledCallButton'
import { AssessmentQuestionnaireView } from './QuestionnaireView'

const scheduledCallButtonProps: ButtonProps = {
  borderLeftRadius: 0,
  borderRightRadius: 4,
  height: '100%',
}
const ScheduledCallView = () => {
  const {
    selectedAssessment: { populated: assessment },
    user,
  } = useProfile()

  const { fname } = user ?? {}

  const text = useMemo(() => {
    if (assessment?.scheduledCall?.callDate) {
      return `Call with ${fname || 'Patient'} occurred on ${getDateString(assessment.scheduledCall.callDate)}.`
    }
    if (assessment?.scheduledCall?.scheduledOn) {
      return `${fname || 'Patient'} has scheduled a call with Hamilton Billing. Report the call date to give the patient access to their assessment.`
    }
    return `Waiting for ${fname || 'patient'} to schedule a call.`
  }, [assessment, fname])
  return (
    <HStack bg="white" borderRadius={4} borderColor="gray.200" borderWidth={1} w="100%" spacing={0}>
      <Box py={2} px={3} flex={1}>
        <Text fontFamily="Open Sans">{text}</Text>
      </Box>
      <ScheduledCallButton buttonProps={scheduledCallButtonProps} />
    </HStack>
  )
}

const AssessmentVisibilityView = () => {
  const {
    selectedAssessment: { populated: assessment, ref: assessmentRef },
  } = useProfile()

  const [isLoading, setIsLoading] = useState(false)
  const { viewableBeforeCall } = assessment ?? {}
  const update = useUpdateDoc('assessment')
  const onToggle = useCallback(
    async (checked: boolean) => {
      if (!assessmentRef) return
      setIsLoading(true)
      try {
        await update(assessmentRef, 'viewableBeforeCall', checked)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    },
    [assessmentRef, update],
  )
  return (
    <HStack
      position="relative"
      bg="white"
      borderRadius={4}
      borderColor="gray.200"
      px={2}
      py={1}
      borderWidth={1}
      w="100%">
      <Checkbox
        colorScheme="green"
        onChange={e => onToggle(e.target.checked)}
        isChecked={!!viewableBeforeCall}>
        <Text fontFamily="Open Sans">Make assessment viewable before HB call</Text>
      </Checkbox>
      <LoadingOverlay loading={isLoading} />
    </HStack>
  )
}

export const AssessmentAnswers: React.FC<{
  assessmentId: string
  onSubmit?: () => Promise<any>
  width: number
}> = ({ onSubmit, assessmentId, width }) => {
  const {
    selectedAssessment: { populated: assessment },
  } = useProfile()

  const { scheduledCall } = assessment ?? {}

  return (
    <VStack bg="gray.50" w="100%" p={3} spacing={2}>
      <ScheduledCallView />
      {scheduledCall?.callDate ? null : <AssessmentVisibilityView />}
      <AssessmentQuestionnaireView assessmentId={assessmentId} />
      {!assessment?.submittedOn && onSubmit ? (
        <ConfirmAlertButton
          mt={4}
          itemName="Questionnaire"
          actionName="Submit"
          w="100%"
          text="Submit Questionnaire"
          onConfirm={onSubmit}
        />
      ) : null}
      <Expandable
        mt={3}
        width={`${width - 40}px`}
        borderRadius={4}
        bg="gray.50"
        headerProps={{ bg: 'white', borderRadius: 4 }}
        border="1px solid #cdcdcd"
        header={() => (
          <Text fontWeight={600} py={1} fontSize="lg" px={2} color="gray.600">
            Log
          </Text>
        )}>
        <Box overflowX="hidden" bg="gray.100" w="100%" height="600px">
          <AssessmentLog maxHeight={600} />
        </Box>
      </Expandable>
    </VStack>
  )
}
